import clsx from "clsx";
import {
  ComponentPropsWithoutRef,
  ReactElement,
  useContext,
  useState,
} from "react";

import { Link } from "./Link.tsx";
import { TableContext } from "./Table.tsx";
import { TableRowContext } from "./TableRow.tsx";

export const TableCell = ({
  children,
  className,
  ...props
}: ComponentPropsWithoutRef<"td">): ReactElement => {
  const { bleed, dense, grid, striped } = useContext(TableContext);
  const { href, target, title } = useContext(TableRowContext);
  const [cellRef, setCellRef] = useState<HTMLElement | null>(null);

  return (
    <td
      ref={href ? setCellRef : undefined}
      {...props}
      className={clsx(
        className,
        "relative first:pl-[var(--gutter,theme(spacing.2))] last:pr-[var(--gutter,theme(spacing.2))]",
        !striped && "border-b border-zinc-950/5 dark:border-white/5",
        grid &&
          "border-l border-l-zinc-950/5 first:border-l-0 dark:border-l-white/5",
        dense ? "px-1 py-1" : "px-4 py-4",
        !bleed && "sm:first:pl-1 sm:last:pr-1",
      )}
    >
      {href && (
        <Link
          aria-label={title}
          className="absolute inset-0 focus:outline-none"
          data-row-link
          href={href}
          tabIndex={cellRef?.previousElementSibling === null ? 0 : -1}
          target={target}
        />
      )}
      {children}
    </td>
  );
};
